import { render, staticRenderFns } from "./Planillas.vue?vue&type=template&id=294803d0"
import script from "./Planillas.vue?vue&type=script&lang=js"
export * from "./Planillas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports